import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'components/modal';
import AsyncSelect from 'react-select/async';
import { Button } from 'react-bootstrap-5';

export default function TeamModal({
  editOrCreateTeam,
  newTeam,
  modalOpen,
  setTeamName,
  teamName,
  onModalClose,
  onSearchTeams,
  onTeamSelect
}) {
  const modalTitle = newTeam ? 'Add Team' : 'Edit Team';
  const actionButtonText = newTeam ? 'Add Team' : 'Update Team Name';

  const invalidTeamName = teamName === '';

  const allowSearch = onSearchTeams && onTeamSelect && newTeam;

  return (
    <Modal show={modalOpen} onHide={onModalClose}>
      <Modal.Header closeButton>
        {modalTitle}
      </Modal.Header>
      <Modal.Body>
        <div>
          {allowSearch && (
            <div>
              <label>Select a team</label>
              <AsyncSelect
                getOptionLabel={team => team.name}
                getOptionValue={team => team.id}
                loadOptions={onSearchTeams}
                placeholder="Add team by name..."
                onChange={onTeamSelect}
              />
              <div className="my-2">OR</div>
            </div>
          )}
          <label className="d-block" htmlFor="team-name">
            {newTeam && 'New '}Team Name<span className="text-destructive"> *</span>
          </label>
          <input
            className="form-control"
            id="team-name"
            type="text"
            value={teamName}
            onChange={e => setTeamName(e.target.value)}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button disabled={invalidTeamName} onClick={editOrCreateTeam}>
          {actionButtonText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

TeamModal.propTypes = {
  editOrCreateTeam: PropTypes.func.isRequired,
  modalOpen: PropTypes.bool.isRequired,
  newTeam: PropTypes.bool.isRequired,
  setTeamName: PropTypes.func.isRequired,
  teamName: PropTypes.string.isRequired,
  onModalClose: PropTypes.func.isRequired,
  onSearchTeams: PropTypes.func,
  onTeamSelect: PropTypes.func
};
